module.exports = __webpack_public_path__ + "img/Entities Inactive.4c2a8f0e.svg";